
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import ProjectGuests from '@/views/project-forum/components/form-components/ProjectGuests.vue';
import BCXInfoSection from '@/components/molecules/BCXInfoSection.vue';
import {
  computed, defineComponent, onMounted, onUnmounted, ref
} from 'vue';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { ProjectGuest } from '@/models/Project';
import useUser from '@/mixins/useUser';
import useProjectGuestState from '@/state/projectGuestState';
import { useStore } from 'vue2-helpers/vuex';

export default defineComponent({
  name: 'ProjectGuestInvitation',
  components: {
    BCXBreadcrumbs,
    ProjectGuests,
    BCXInfoSection
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const {
      companyId, projectList, resetNewProjectGuest
    } = useProjectGuestState(store.state.projectForum.project?.company?.id);
    companyId.value = store.state.projectForum.project?.company?.id;
    projectList.value = [store.state.projectForum.project?.id];

    const guestList = ref<ProjectGuest[]>([]);
    const { tUserFallback: t, isCustomer } = useUser('self');

    const breadcrumbItems = computed(() => {
      const breadcrumbItems:Array<{text:string; to?:any}> = [
        {
          text: t('project-forum_USERTYPE.labels.projects').toString(),
          to: { name: 'projectList' }
        },
        {
          text: t('project-forum_USERTYPE.labels.create-project').toString(),
          to: { name: 'createProject' }
        }
      ];
      return breadcrumbItems;
    });

    const closeInvitation = () => {
      resetNewProjectGuest();
      router.push({ name: 'projectForumThread', params: { projectId: route.params.projectId } });
    };

    const finish = () => {
      closeInvitation();
    };

    onMounted(() => {
      if (companyId.value === null || !isCustomer.value) {
        closeInvitation();
      }
    });

    onUnmounted(() => {
      resetNewProjectGuest();
    });

    return {
      t,
      closeInvitation,
      breadcrumbItems,
      guestList,
      finish
    };
  },
});
